import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewContainerRef
} from '@angular/core';
import { ItemAttribute } from '../../../models/item';
import { MatDialog } from '@angular/material/dialog';
import { TrackedAttributesPromptDialogComponent } from './tracked-attributes-prompt-dialog/tracked-attributes-prompt-dialog.component';
import { take } from 'rxjs/operators';
import { ItemAttributesService } from '../../services/item-attributes.service';
import { TestIdDirective } from '../../directives/test-id.directive';
import { NgIf } from '@angular/common';

const listFormatter = new Intl.ListFormat('en-GB', {
  style: 'long',
  type: 'conjunction'
});

@Component({
  selector: 'app-tracked-attributes-prompt',
  templateUrl: './tracked-attributes-prompt.component.html',
  providers: [ItemAttributesService],
  standalone: true,
  imports: [NgIf, TestIdDirective]
})
export class TrackedAttributesPromptComponent implements OnInit {
  @Input() attributes: ItemAttribute[];
  @Input() event: PromptEvent;
  @Input() promptableType: 'hireItem' | 'workshopJob' | 'deliveryItem';
  @Input() promptableId: number;
  @Input() itemCode: string;
  @Input() itemId: number;
  @Output() addedAttributes = new EventEmitter<{ itemUpdated: boolean }>();

  enabledAttributes: ItemAttribute[];
  promptText: string;
  show = false;

  constructor(
    private dialog: MatDialog,
    private vcr: ViewContainerRef
  ) {}

  ngOnInit() {
    this.enabledAttributes = this.attributes.filter(
      (attr) => attr.prompts[this.event] && attr.prompts[this.event].enabled
    );
    this.show = this.enabledAttributes.length > 0;
    this.promptText = `Update ${listFormatter.format(
      this.enabledAttributes.map((attr) => attr.name)
    )}`;
    this.handlePopupAttributes();
  }

  handlePopupAttributes() {
    const popupAttributes = this.enabledAttributes.filter((attr) => {
      return (
        attr.prompts[this.event] && attr.prompts[this.event].type === 'popup'
      );
    });
    if (popupAttributes.length) {
      this.openDialog();
    }
  }

  openDialog() {
    this.dialog
      .open(TrackedAttributesPromptDialogComponent, {
        data: {
          attributes: this.enabledAttributes,
          promptableType: this.promptableType,
          promptableId: this.promptableId,
          itemCode: this.itemCode,
          itemId: this.itemId,
          event: this.event
        },
        viewContainerRef: this.vcr
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          this.show = false;
          this.addedAttributes.next({
            itemUpdated: result?.promptableUpdated
          });
        }
      });
  }
}

export type PromptEvent =
  | 'on_hire'
  | 'off_hire'
  | 'delivery'
  | 'collection'
  | 'workshop_job_complete';
